import { Hub, Laptop, Office, People, Pin, Salad } from '@factorialco/f0-react/icons/app'
import Booth from 'assets/images/space_control/space-booth-placeholder.png'
import Desk from 'assets/images/space_control/space-image-placeholder.png'
import Lunch from 'assets/images/space_control/space-lunch-placeholder.png'
import MeetingRoom from 'assets/images/space_control/space-meeting_room-placeholder.png'
import Other from 'assets/images/space_control/space-other-placeholder.png'
import Parking from 'assets/images/space_control/space-parking-placeholder.png'

export const useWorkSpaceUI = (type: string) => {
  switch (type) {
    case 'meeting_room':
      return { icon: People, placeholder: MeetingRoom }
    case 'desk':
      return { icon: Laptop, placeholder: Desk }
    case 'lunch':
      return { icon: Salad, placeholder: Lunch }
    case 'booth':
      return { icon: Office, placeholder: Booth }
    case 'parking':
      return { icon: Pin, placeholder: Parking }
    case 'other':
      return { icon: Hub, placeholder: Other }
  }
  return { icon: Hub, placeholder: Other }
}
